<template>
  <div class="animated fadeIn">
    <div class="form-group row">
      <div class="col-md-12">
        <div class="nav-serasa">
          <b-tabs
            content-class="no-border"
            pills
            fill
            align="center"
            style="border: solid 1px #efefef; border-radius: 5px;"
          >
            <b-tab
              :title="'Informações'"
              class="no-border"
              v-if="serasa"
            >
              <div>
                <span><strong>Última consulta Serasa: </strong>{{
                    moment
                      .utc(this.serasa.dataConsulta, moment.ISO_8601)
                      .format("DD/MM/YYYY")}}</span>
              </div>
              <div class="form-group row pt-4" v-if="serasa.infoCadastraisCreditBureau">
                <div class="col-md-12">
                  <label><strong>Documento:</strong></label>
                  {{ this.serasa.infoCadastraisCreditBureau.document }}
                </div>
                <div class="col-md-12">
                  <label><strong>Situação Documento:</strong></label>
                  {{ this.serasa.infoCadastraisCreditBureau.situacaoDocumento }}
                </div>
                <div class="col-md-12">
                  <label><strong>RG:</strong></label>
                  {{ this.serasa.infoCadastraisCreditBureau.rg }}
                </div>
                <div class="col-md-12">
                  <label><strong>Data de Nascimento:</strong></label>
                  {{
                    moment
                      .utc(this.serasa.infoCadastraisCreditBureau.dataNascimento, moment.ISO_8601)
                      .format("DD/MM/YYYY")}}
                </div>
                <div class="col-md-12">
                  <label><strong>CEP:</strong></label>
                  {{ this.serasa.infoCadastraisCreditBureau.cep }}
                </div>
                <div class="col-md-12">
                  <label><strong>Escolaridade:</strong></label>
                  {{ this.serasa.infoCadastraisCreditBureau.escolaridade ?
                  this.serasa.infoCadastraisCreditBureau.escolaridade : 'Não informado' }}
                </div>
                <div class="col-md-12">
                  <label><strong>Estado Civil:</strong></label>
                  {{ this.serasa.infoCadastraisCreditBureau.estadoCivil ?
                  this.serasa.infoCadastraisCreditBureau.estadoCivi : 'Não informado'}}
                </div>
                <div class="col-md-12">
                  <label><strong>Celular:</strong></label>
                  {{ this.serasa.infoCadastraisCreditBureau.celular }}
                </div>
                <div class="col-md-12 d-flex justify-content-between" v-if="this.serasa.infoCadastraisCreditBureau.score">
                  <div>
                    <label><strong>Score:</strong></label>
                    {{ (this.serasa.infoCadastraisCreditBureau.score) }}
                  </div>
                  <div>
                    <label class="pl-3"><strong>Data Consulta:</strong></label>
                    {{ moment
                    .utc(this.serasa.infoCadastraisCreditBureau.dataConsultaScore, moment.ISO_8601)
                    .format("DD/MM/YYYY") }}
                  </div>
                </div>
                <div class="col-md-12 d-flex justify-content-between" v-if="this.serasa.infoCadastraisCreditBureau.renda">
                  <div>
                    <label><strong>Renda:</strong></label>
                    {{ formatNumberToReal(this.serasa.infoCadastraisCreditBureau.renda) }}
                  </div>
                  <div v-if="true">
                    <label><strong>Data Consulta:</strong></label>
                    {{ moment
                    .utc(this.serasa.infoCadastraisCreditBureau.dataConsultaRenda, moment.ISO_8601)
                    .format("DD/MM/YYYY") }}
                  </div>
                </div>
              </div>
              <div class="form-group row pt-4" v-if="serasa.infoCadastraisRelato">
                <div class="col-md-12">
                  <label><strong>Documento:</strong></label>
                  {{ this.serasa.infoCadastraisRelato.document }}
                </div>
                <div class="col-md-12">
                  <label><strong>Situação Empresa:</strong></label>
                  {{ this.serasa.infoCadastraisRelato.situacaoEmpresa }}
                </div>
                <div class="col-md-12">
                  <label><strong>Razão Social:</strong></label>
                  {{ this.serasa.infoCadastraisRelato.razaoSocial }}
                </div>
                <div class="col-md-12">
                  <label><strong>Nome fantasia:</strong></label>
                  {{ this.serasa.infoCadastraisRelato.nomeFantasia }}
                </div>
                <div class="col-md-12">
                  <label><strong>Ramo:</strong></label>
                  {{ this.serasa.infoCadastraisRelato.ramo }}
                </div>
                <div class="col-md-12">
                  <label><strong>Data Fundação:</strong></label>
                  {{ moment
                  .utc(this.serasa.infoCadastraisRelato.dataFundacao, moment.ISO_8601)
                  .format("DD/MM/YYYY")}}
                </div>
<!--                <div class="col-md-12">-->
<!--                  <label><strong>Email:</strong></label>-->
<!--                  {{ this.serasa.infoCadastraisRelato.email }}-->
<!--                </div>-->
                <div class="col-md-12">
                  <label><strong>Telefone:</strong></label>
                  {{ this.serasa.infoCadastraisRelato.telefone }}
                </div>
                <div class="col-md-12">
                  <label><strong>Quantidade Filiais:</strong></label>
                  {{ this.serasa.infoCadastraisRelato.quantidadeFiliais }}
                </div>

              </div>
            </b-tab>
            <b-tab
              :title="'Sócios'"
              class="no-border"
              v-if="serasa.socio"
            >
              <div>
                <label><strong>Data consulta de Sócios:</strong></label>
                {{ this.serasa.dataConsultaSocio ? moment
                .utc(this.serasa.dataConsultaSocio, moment.ISO_8601)
                .format("DD/MM/YYYY") : 'Consulta não realizada' }}
              </div>
              <div class="form-group row pt-4" v-for="(detalhe, index) in this.serasa.socio" :key="index" v-show="showAll || index < 1">
                <div class="col-md-12">
                  <label><strong><u>SÓCIO {{ index+1 }}</u></strong></label>
                </div>
                <div class="col-md-12">
                  <label><strong>Percentual Capital: &nbsp;</strong></label>
                  {{ detalhe.percentualCapital }}
                </div>
                <div class="col-md-12">
                  <label><strong>Nome Sócio: &nbsp;</strong></label>
                  {{ detalhe.nomeSocio }}
                </div>
                <div class="col-md-12">
                  <label><strong>Documento: &nbsp;</strong></label>
                  {{ detalhe.documento }}
                </div>
                <div class="col-md-12">
                  <label><strong>Date de Entrada: &nbsp;</strong></label>
                  {{ moment
                  .utc(detalhe.dataEntrada, moment.ISO_8601)
                  .format("DD/MM/YYYY") }}
                </div>
                <div class="col-md-12">
                  <label><strong>Tipo de Pessoa: &nbsp;</strong></label>
                  {{ detalhe.tipoPessoa === 'F' ? 'Física' : 'Jurídica' }}
                </div>
                <div class="col-md-12">
                  <label><strong>Sócio Possui Anotações: &nbsp;</strong></label>
                  {{ detalhe.possuiRestricoes ? "Sim" : "Não" }}
                </div>
              </div>
              <div class="d-flex justify-content-center w-100">
                <div>
                  <default-button :text="showAll ? 'Ver menos' : 'Ver mais' " :on-click="toggleShowAll" btnVariant="btn-third" v-if="countOcorrencia(this.serasa.socio) > 1"/>
                </div>
              </div>
            </b-tab>
            <b-tab
              :title="'Pendências'"
              class="no-border"
              v-if="serasa.pendenciasPagamento"
            >
              <div class="form-group row pt-4">
                <div class="col-md-12">
                  <label><strong>Valor Total:</strong></label>
                  R$ {{ sumValorOcorrencia(this.serasa.pendenciasPagamento.detalhes) }}
                </div>
                <div class="col-md-12">
                  <label><strong>Quantidade de pendências: &nbsp;</strong></label>
                  {{ countOcorrencia(this.serasa.pendenciasPagamento.detalhes) }}
                </div>
              </div>
              <div class="form-group row pt-4" v-for="(detalhe, index) in this.serasa.pendenciasPagamento.detalhes" :key="index" v-show="showAll || index < 1">
                <div class="col-md-12">
                  <label><strong><u>PENDÊNCIA DE PAGAMENTO {{ index+1 }}</u></strong></label>
                </div>
                <div class="col-md-12">
                  <label><strong>Valor: &nbsp;</strong></label>
                  {{ detalhe.tipoMoeda + parseInt(detalhe.valorOcorrencia) }}
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Tipo: &nbsp;</strong></label>
                    {{ detalhe.tipo }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Data Ocorrência: &nbsp;</strong></label>
                    {{ formatDate(detalhe.dataOcorrencia) }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Origem: &nbsp;</strong></label>
                    {{ detalhe.empresaOrigem }}
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center w-100">
                <div>
                  <default-button :text="showAll ? 'Ver menos' : 'Ver mais' " :on-click="toggleShowAll" btnVariant="btn-third" v-if="countOcorrencia(this.serasa.pendenciasPagamento.detalhes) > 1"/>
                </div>
              </div>
            </b-tab>
            <b-tab
              :title="'Cheque s/ Fundo'"
              class="no-border"
              v-if="serasa.chequeSemFundo"
            >
              <div class="form-group row pt-4">
                <div class="col-md-12">
                  <label><strong>Valor Total:</strong></label>
                  R$ {{ this.serasa.chequeSemFundo.valorTotal ? this.serasa.chequeSemFundo.valorTotal : 0 }}
                </div>
                <div class="col-md-12">
                  <label><strong>Quantidade de pendências: &nbsp;</strong></label>
                  {{ countOcorrencia(this.serasa.chequeSemFundo.detalhes) }}
                </div>
              </div>
              <div class="form-group row pt-4" v-for="(detalhe, index) in this.serasa.chequeSemFundo.detalhes" :key="index" v-show="showAll || index < 1">
                  <div class="col-md-12">
                    <label><strong><u>CHEQUE SEM FUNDO {{ index+1 }}</u></strong></label>
                  </div>
                  <div class="col-md-12">
                    <label><strong>Valor: &nbsp;</strong></label>
                    {{ detalhe.tipoMoeda + parseInt(detalhe.valorOcorrencia) }}
                  </div>
                  <div class="col-md-12">
                    <div class="input-group">
                      <label><strong>Tipo: &nbsp;</strong></label>
                      CHEQUE SEM FUNDO
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="input-group">
                      <label><strong>Data Ocorrência: &nbsp;</strong></label>
                      {{ formatDate(detalhe.dataOcorrencia) }}
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="input-group">
                      <label><strong>Origem: &nbsp;</strong></label>
                      {{ detalhe.empresaOrigem }}
                    </div>
                  </div>
                </div>
              <div class="d-flex justify-content-center w-100">
                <div>
                  <default-button :text="showAll ? 'Ver menos' : 'Ver mais' " :on-click="toggleShowAll" btnVariant="btn-third" v-if="countOcorrencia(this.serasa.chequeSemFundo.detalhes) > 1"/>
                </div>
              </div>
            </b-tab>
            <b-tab
              :title="'Protesto'"
              class="no-border"
              v-if="serasa.protesto"
            >
              <div class="form-group row pt-4">
                <div class="col-md-12">
                  <label><strong>Valor Total:</strong></label>
                  R$ {{ sumValorOcorrencia(this.serasa.protesto.detalhes) }}
                </div>
                <div class="col-md-12">
                  <label><strong>Quantidade de pendências: &nbsp;</strong></label>
                  {{ countOcorrencia(this.serasa.protesto.detalhes) }}
                </div>
              </div>
              <div class="form-group row pt-4" v-for="(detalhe, index) in this.serasa.protesto.detalhes" :key="index" v-show="showAll || index < 1">
                <div class="col-md-12">
                  <label><strong><u>PROTESTO {{ index+1 }}</u></strong></label>
                </div>
                <div class="col-md-12">
                  <label><strong>Valor: &nbsp;</strong></label>
                  {{ detalhe.tipoMoeda + parseInt(detalhe.valorOcorrencia) }}
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Tipo: &nbsp;</strong></label>
                    PROTESTO
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Data Ocorrência: &nbsp;</strong></label>
                    {{ formatDate(detalhe.dataOcorrencia) }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Origem: &nbsp;</strong></label>
                    {{ detalhe.empresaOrigem }}
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center w-100">
                <div>
                  <default-button :text="showAll ? 'Ver menos' : 'Ver mais' " :on-click="toggleShowAll" btnVariant="btn-third" v-if="countOcorrencia(this.serasa.protesto.detalhes) > 1"/>
                </div>
              </div>
            </b-tab>
            <b-tab
              :title="'Ações Judiciais'"
              class="no-border"
              v-if="serasa.acoesJudiciais"
            >
              <div class="form-group row pt-4">
                <div class="col-md-12">
                  <label><strong>Valor Total:</strong></label>
                  R$ {{ sumValorOcorrencia(this.serasa.acoesJudiciais.detalhes) }}
                </div>
                <div class="col-md-12">
                  <label><strong>Quantidade de pendências: &nbsp;</strong></label>
                  {{ countOcorrencia(this.serasa.acoesJudiciais.detalhes) }}
                </div>
              </div>
              <div class="form-group row pt-4" v-for="(detalhe, index) in this.serasa.acoesJudiciais.detalhes" :key="index" v-show="showAll || index < 1">
                <div class="col-md-12">
                  <label><strong><u>AÇÃO JUDICIAL {{ index+1 }}</u></strong></label>
                </div>
                <div class="col-md-12">
                  <label><strong>Valor: &nbsp;</strong></label>
                  {{ detalhe.tipoMoeda + parseInt(detalhe.valorOcorrencia) }}
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Tipo: &nbsp;</strong></label>
                    Ações Judiciais
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Data Ocorrência: &nbsp;</strong></label>
                    {{ formatDate(detalhe.dataOcorrencia) }}
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="input-group">
                    <label><strong>Origem: &nbsp;</strong></label>
                    {{ detalhe.empresaOrigem }}
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center w-100">
                <div>
                  <default-button :text="showAll ? 'Ver menos' : 'Ver mais' " :on-click="toggleShowAll" btnVariant="btn-third" v-if="countOcorrencia(this.serasa.acoesJudiciais.detalhes) > 1"/>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'

import TextTruncate from './TextTruncate.vue'
import DefaultButton from '@/components/UI/button/defaultButton.vue'

export default {
  name: 'CrmDetailsSerasa',
  mixins: [ActionsForm],
  props: {
    serasa: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data: null,
      form: null,
      showAll: false
    }
  },
  components: {
    DefaultButton,
    TextTruncate
  },
  methods: {
    onLoad () {
    },
    onReload () {
      this.$emit('Reload')
    },
    formatDate (date) {
      const dateObj = new Date(date)
      dateObj.setDate(dateObj.getDate() + 1)

      return dateObj.toLocaleString('pt-BR', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric'
      })
    },
    sumValorOcorrencia (ocorrencia) {
      let sum = 0
      ocorrencia.forEach(function (x) {
        sum += parseInt(x.valorOcorrencia)
      })
      return sum
    },
    countOcorrencia (ocorrencia) {
      let count = 0
      if (!ocorrencia) return count
      ocorrencia.forEach(function (x) {
        count++
      })
      return count
    },
    toggleShowAll () {
      this.showAll = !this.showAll
    },
    formatNumberToReal (value) {
      let brazilianReal = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      })
      return brazilianReal.format(value.substring(0, value.length - 2))
    }
  }
}
</script>
<style lang="scss">
.nav.nav-pills {
  li.nav-item {
    margin-bottom: 0.2rem;
  }
}
.nav-serasa .nav-link:not(.active) {
  background-color: #fff;
  color: #04A791;
  border: 1px solid #04A791;
}
.nav-serasa .nav-link.active {
  background-color: #04A791;
  color: #fff;
}
.show-more-btn {
  background-color: #007bff;
  color: #ffffff;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.3s ease;
}

/* Estilo quando o cursor está sobre o botão */
.show-more-btn:hover {
  background-color: #0056b3; /* Cor de fundo alterada quando o cursor está sobre o botão */
}

</style>
<style scoped>
.no-border {
  border: 0px;
}

.tab-content {
  border: 0px solid #cfd8dc;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/details/serasa/SerasaDetails.vue